import { GET_USERS, SAVE_USER } from '../actions.type'
import { SET_USERS } from '../mutations.type'
import UserService from '@/services/UserService'

const state = {
  users: {},
  usersList: []
}

const getters = {
  users: state => state.usersList.map(id => state.users[id])
}

const actions = {
  [GET_USERS]: ({ commit }) => {
    return new Promise((resolve, reject) => {
      UserService.getUsers()
        .then(response => {
          if (response.data) {
            if (response.data.error) {
              reject(response.data.error)
            } else if (response.data.data) {
              commit(SET_USERS, response.data.data)
              resolve()
            } else {
              reject('NO DATA')
            }
          } else {
            reject('NO RESPONSE')
          }
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  [SAVE_USER]: (undefined, user) => {
    const updates = {
      id: user.id,
      email: user.email,
      firstName: user.firstName,
      lastName: user.lastName,
      status: user.status
    }
    return new Promise((resolve, reject) => {
      UserService.saveUser(updates)
        .then(response => {
          if (response.data) {
            if (response.data.error) {
              reject(response.data.error)
            } else if (response.data.data) {
              resolve()
            } else {
              reject('NO DATA')
            }
          } else {
            reject('NO RESPONSE')
          }
        })
        .catch(err => {
          reject(err)
        })
    })
  }
}

// basic mutations, showing loading, success, error to reflect the api call status and the token when loaded
const mutations = {
  [SET_USERS]: (state, data) => {
    const users = {}
    data.forEach(user => {
      users[user.id] = user
    });
    state.users = Object.assign({}, users)
    state.usersList = Object.keys(users)
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
